import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { startCase } from 'lodash';
import showBarrier from '../../../utils/showBarrier';

const SubNavLink = ({ url, tabName, tabUrl }) => (
    <Link
        to={`${url}/${tabUrl}`}
        className="ui-link ui-link_primary ui-popoverList__link pp-subTabs__tab"
        activeClassName="pp-subTabs__tab_selected"
        onClick={event => showBarrier(event, `${url}/${tabUrl}`)}
    >
        {
            tabName === 'progeny-dams-sire'
                ? 'Damsire'
                : startCase(tabName)
        }
    </Link>
);

SubNavLink.propTypes = {
    url: PropTypes.string.isRequired,
    tabName: PropTypes.string.isRequired,
    tabUrl: PropTypes.string.isRequired,
};

export default SubNavLink;



// WEBPACK FOOTER //
// ./src/js/shared/nav/components/SubNavLink.jsx